var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1349,
    height: 215,
    viewBox: "0 0 1349 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1224.54 114.303C1239.28 83.7124 1279.55 90.9959 1287.71 114.303C1296.66 104.106 1350.81 102.224 1348.95 139.311C1310.26 145.563 1209.61 145.563 1170.92 139.311C1163.58 123.59 1201.91 95.3662 1224.54 114.303Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1224.34 28.2894C1224.34 29.6333 1225.62 32.0904 1227.48 32.4002C1229.32 31.9722 1228.66 28.7701 1229.68 29.5542C1231.76 29.8641 1230.78 33.6189 1241 34.6139C1236.94 28.8628 1234.21 29.8242 1233.45 27.6569C1232.7 25.8586 1234.58 26.3457 1235.03 24.8109C1235.08 24.2775 1231.35 25.5024 1231.25 24.8109C1230.21 22.6568 1224.75 14.8034 1224.34 15.6403C1223.92 16.4772 1224.31 23.8159 1228.11 27.3407C1226.61 28.5729 1225.01 27.3802 1224.34 28.2894Z",
    fill: "#6892CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1141.44 16.2881C1141.44 17.3597 1142.45 19.3189 1143.91 19.566C1145.36 19.2247 1144.84 16.6714 1145.64 17.2967C1147.27 17.5437 1146.51 20.5377 1154.54 21.3312C1151.35 16.7453 1149.2 17.5119 1148.61 15.7838C1148.02 14.3498 1149.49 14.7382 1149.85 13.5144C1149.89 13.089 1146.96 14.0658 1146.88 13.5144C1146.06 11.7968 1141.77 5.53458 1141.44 6.20191C1141.12 6.86923 1141.42 12.721 1144.41 15.5316C1143.23 16.5141 1141.97 15.5631 1141.44 16.2881Z",
    fill: "#6892CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1211.13 16.9031C1212.23 17.1404 1212.15 16.5142 1212.39 15.0058C1212.89 13.9453 1212.99 14.5642 1213.96 14.0571C1214.94 13.5501 1215.66 14.0635 1215.85 13.4247C1216.04 12.7858 1218.31 13.1412 1218.68 12.7922C1218.52 12.4696 1217.03 12.3969 1216.48 11.8435C1215.93 11.2901 1216.76 11.2438 1216.79 10.5786C1216.38 10.4669 1214.74 11.5073 1213.96 10.5786C1212.76 8.20056 1211.84 6.94838 1208.93 5.20275C1206.61 4.51422 1207.25 5.76906 1207.36 6.15146C1208.26 7.73561 1208.37 7.22684 1208.93 8.36504C1209.59 9.75531 1210.08 11.2901 1211.13 12.7922C1211.13 14.4524 1208.98 13.5101 1207.99 14.0571C1207.39 15.1575 1210.03 16.666 1211.13 16.9031Z",
    fill: "#6892CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1191.01 21.9621C1192.58 22.3047 1193.65 21.112 1194.16 21.3296C1193.95 22.2061 1193 23.7736 1192.58 23.8595C1192.17 23.9453 1194.41 27.8845 1194.16 28.9191C1193.9 29.9536 1195.46 31.89 1195.41 32.7138C1193.06 33.4584 1191.03 28.4116 1189.13 26.073C1188.29 26.1062 1188.05 27.5683 1187.55 27.6541C1187.06 27.74 1185.35 26.7777 1185.67 24.4919C1186.59 24.1825 1187.65 24.7223 1188.18 23.8595C1187.22 23.1284 1184.75 19.0566 1185.67 17.2187C1185.96 16.6985 1186.27 17.1856 1186.92 17.8512C1188.19 18.2796 1189.57 20.6972 1191.01 21.9621Z",
    fill: "#6892CF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1195.41 41.8844C1194.68 41.6999 1192.22 42.5432 1191.01 40.3033C1190.44 40.2512 1189.38 39.9914 1188.81 40.3033C1187.55 40.5668 1186.64 40.9357 1185.98 40.9357C1186.19 41.5945 1189.11 42.1743 1189.44 43.1493C1189.01 44.0716 1188.66 44.0716 1187.55 44.098C1187.21 43.4392 1188.09 45.4946 1188.81 46.3115C1189.84 45.5473 1190.65 44.6382 1190.7 45.0467C1192.27 45.0071 1194.18 51.0022 1194.47 51.0549C1194.86 51.8455 1195.51 52.5438 1195.41 51.3711C1195.42 49.8032 1195.52 46.3774 1195.41 45.6791C1195.31 44.9808 1194.42 44.5591 1194.16 44.098C1193.89 43.6368 1195.12 42.7804 1195.41 41.8844Z",
    fill: "#6892CF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144.43 31.9C1143.7 31.7156 1141.24 32.5588 1140.03 30.3189C1139.46 30.2669 1138.4 30.007 1137.83 30.3189C1136.57 30.5824 1135.66 30.9513 1135 30.9513C1135.21 31.6102 1138.13 32.1899 1138.46 33.1649C1138.02 34.0872 1137.67 34.0872 1136.57 34.1136C1136.23 33.4548 1137.11 35.5102 1137.83 36.3272C1138.86 35.563 1139.67 34.6538 1139.72 35.0623C1141.29 35.0228 1143.2 41.0178 1143.49 41.0705C1143.88 41.8611 1144.53 42.5594 1144.43 41.3868C1144.44 39.8188 1144.54 36.3931 1144.43 35.6947C1144.32 34.9964 1143.44 34.5748 1143.17 34.1136C1142.91 33.6524 1144.14 32.796 1144.43 31.9Z",
    fill: "#6892CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1171.83 46.6294C1171.52 47.0642 1171.36 48.0128 1171.21 48.5267C1171.58 49.4556 1173.58 48.474 1173.41 53.5863C1173.17 54.7261 1172.46 53.2174 1172.15 52.6377C1171.78 52.0382 1169.79 49.818 1169 50.7403C1168.26 51.6626 1168.55 52.8617 1168.06 52.6377C1167.57 52.4137 1165.13 50.1342 1165.86 49.7916C1168.2 49.1724 1167.7 47.6242 1167.43 46.6294C1167.15 46.0191 1166.64 45.243 1166.49 45.0483C1166.36 44.7254 1166.21 44.4224 1166.49 44.4158C1167.22 44.3104 1169.77 43.9283 1169.95 46.6294C1170.44 47.4924 1171.38 46.6887 1171.83 46.6294Z",
    fill: "#6892CF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1197.13 8.05125C1196.82 8.48606 1196.66 9.43472 1196.5 9.94859C1196.88 10.8775 1198.88 9.8959 1198.7 15.0082C1198.47 16.1479 1197.76 14.6393 1197.45 14.0595C1197.08 13.46 1195.08 11.2399 1194.3 12.1622C1193.56 13.0845 1193.85 14.2835 1193.36 14.0595C1192.87 13.8355 1190.43 11.5561 1191.16 11.2135C1193.5 10.5942 1193 9.04604 1192.73 8.05125C1192.45 7.44094 1191.94 6.66484 1191.79 6.47014C1191.65 6.14732 1191.51 5.84428 1191.79 5.83769C1192.52 5.73228 1195.06 5.35017 1195.25 8.05125C1195.74 8.91427 1196.68 8.11054 1197.13 8.05125Z",
    fill: "#6892CF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.27 191.243C186.963 166.77 218.907 172.597 225.381 191.243C232.48 183.085 275.439 181.579 273.963 211.249C243.27 216.25 163.421 216.25 132.729 211.249C126.91 198.672 157.314 176.093 175.27 191.243Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.442 74.4305C52.641 51.1814 83.2352 56.7169 89.4349 74.4304C96.2345 66.6808 137.378 65.2504 135.964 93.4364C106.569 98.1879 30.0935 98.1879 0.697784 93.4364C-4.8752 81.4884 24.2442 60.0383 41.442 74.4305Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.394 15.25V14.25L202.67 8.5L196.711 7H202.67L203.415 0L204.904 7L209.125 5.75L206.394 8C206.394 8 209.725 12.125 212.85 14.25C218.457 13.9167 225.016 10 225.016 10C225.016 10 225.306 8.79166 225.761 8.5C226.175 8.45833 225.968 10.6875 225.761 10.75C223.361 12.9792 218.685 14.6042 216.823 15.25C215.871 16.1875 218.064 17.5 218.064 17.5C218.064 17.5 218.374 18.625 218.064 19C217.754 19.375 216.823 19 216.823 19L215.829 21L214.836 22H213.843L212.85 20C212.85 20 210.574 18.2083 209.125 17.5C207.512 17.1667 206.394 17.5 206.394 17.5L206.643 20C206.643 20 204.481 19.8862 203.911 18.25C204.086 16.8638 202.67 16.25 202.67 16.25L191 14.25L206.394 15.25Z",
    fill: "#6295E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M806.27 54.2426C817.963 29.7699 849.907 35.5967 856.381 54.2426C863.48 46.0851 906.439 44.5793 904.963 74.2488C874.27 79.2504 794.421 79.2504 763.729 74.2488C757.91 61.672 788.314 39.093 806.27 54.2426Z",
    fill: "url(#paint3_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 1188.25,
    y1: 94,
    x2: 1188.25,
    y2: 133.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 146.48,
    y1: 175,
    x2: 146.48,
    y2: 206.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 13.8678,
    y1: 59,
    x2: 13.8678,
    y2: 89.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 777.48,
    y1: 38,
    x2: 777.48,
    y2: 69.8425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaven);
export default __webpack_public_path__ + "static/media/heaven.d6029cdb6fbe8ff748366a07bd34f6bb.svg";
export { ForwardRef as ReactComponent };